var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grow has-text-centered mt-xl"},[_c('b-icon',{attrs:{"icon":"x","size":"is-large3","type":"is-danger"}}),_c('p',[_vm._v("Spotify link failed. Please try again.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }